import { PaymentsHttpHelper, NO_DATA_MESSAGE, BASIC_INITIAL_STATE } from '@usas/ui-web/utils/HttpHelper';

const getPendingPayments = (state, setState) => {
  if (state.isArrayLoading !== true && state.isArrayLoaded !== true && !state.message) {
    let newState = {
      ...state,
      isArrayLoading: true,
      isArrayLoaded: false,
      arrayData: [],
      message: 'Loading...'
    };
    setState(newState);

    const url = `/Payments/Cart/OpenItem`;
    PaymentsHttpHelper(url, 'GET')
      .then((arrayData) => {
        if (!arrayData) arrayData = [];
        if (Array.isArray(arrayData) === false) {
          throw new Error(NO_DATA_MESSAGE);
        } else {
          newState = {
            ...newState,
            isArrayLoading: false,
            isArrayLoaded: true,
            arrayData,
            message: '',
          };
          setState(newState);
          return arrayData;
        }
      })
      .catch((e) => {
        const message = e && e.message ? e.message : NO_DATA_MESSAGE;
        setState({
          ...newState,
          isArrayLoading: false,
          isArrayLoaded: false,
          message: message
        });
      });
  };
};

const PendingPaymentsData = { INITIAL_STATE: BASIC_INITIAL_STATE, getPendingPayments };
export default PendingPaymentsData;